import React from "react";
import { RuletabContainer } from "../../../containers";
const Ruletab = (props) => {
  return <RuletabContainer {...props} />;
};

export default Ruletab;
